import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Colors from '@constants/Colors';

const LinkStyles = `margin-right: 32px;
font-size: 14px;
line-height: 16px;
text-decoration: none;
color: inherit;
transition: 200ms ease-in-out;

:hover {
  color: ${Colors.periwinkleStrong};
}

@media (max-width: 576px) {
  margin-right: 0;
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 26px;

  :last-of-type {
    margin-bottom: 0;
  }
}`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const HeaderLinksContainer = styled(Wrapper)`
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    align-self: flex-start;
  }
`;

export const HeaderLink = styled(Link)`
  ${LinkStyles}
`;
export const AnchorLink = styled.a`
  ${LinkStyles}
`;

export const NewHeaderLink = styled(HeaderLink)`
  padding-right: 36px;
  position: relative;

  ::after {
    content: 'Novo';
    padding: 5px;
    padding-top: 7px;
    font-size: 8px;
    font-weight: 300;
    line-height: 0;
    color: white;
    text-transform: uppercase;
    position: absolute;
    top: -8px;
    right: 0;
    border-radius: 4px;
    background-color: ${Colors.periwinkleStrong};
  }

  @media (max-width: 576px) {
    padding-right: 44px;

    ::after {
      padding: 6px;
      padding-top: 7px;
    }
  }
`;

export const BoxWrapper = styled.div`
  position: relative;
  color: #000;
`;

export const UserDisplay = styled.div`
  padding: 4px 8px 4px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border: 1px solid ${Colors.lightGreyish};
  border-radius: 200px;
  cursor: pointer;

  > p {
    font-size: 12px;
    margin-right: 8px;
    ::selection {
      color: inherit;
    }
  }

  @media (max-width: 576px) {
    padding: 0;
    border: none;

    > p {
      display: none;
    }
  }
`;

export const Character = styled.span`
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #efd9ff;
  position: relative;


  ::before{
    content: '${({ character }) => character}';
    color: #9000ff;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 576px) {
    position: relative;
    
    ::after {
      content: "";
      width: 6px;
      height: 6px;
      position: absolute;
      top: 0px;
      right: 0px;
      border: 2px solid white;
      border-radius: 50%;
      background-color: ${Colors.periwinkleStrong};
      display: ${({ boxOpen, hasSeen }) => (boxOpen || hasSeen ? 'none' : 'block')}
    }
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 20px;
  min-width: 256px;
  box-shadow: 0 5px 40px 0 rgba(0, 0, 0, 0.15);
  padding: 24px;
  padding-bottom: 16px;
  background-color: #fff;
  z-index: 9;

  ${Character} {
    margin-bottom: 16px;
    width: 56px;
    height: 56px;

    ::before {
      font-size: 20px;
    }
  }

  h6 {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    max-width: 208px;
    text-align: center;
    text-transform: capitalize;
    text-overflow: ellipsis;
    white-space: pre;
    overflow: hidden;
  }

  @media screen and (max-width: 767px) {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 9;
    background: #fff;
    margin-top: 0;
    padding-top: 48px;

    h6 {
      text-align: left;
    }
  }
`;

export const UserEmail = styled.p`
  max-width: 208px;
  margin-top: 6px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 300;
  color: #859099;
  text-align: center;
  text-overflow: ellipsis;
  white-space: pre;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    margin: 0;
    margin-top: 4px;
    font-weight: 300;
    text-align: left;
    color: ${Colors.bluishGrey};
  }
`;

export const ActionsHeaderContainer = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  align-self: flex-start;

  ${Character} {
    margin-bottom: 0;
    margin-right: 16px;
  }

  @media screen and (min-width: 767px) {
    margin-top: 0;
    flex-direction: column;
    align-self: center;

    ${Character} {
      margin-bottom: 16px;
      margin-right: 0;
    }
  }
`;

export const Divider = styled.div`
  display: flex;
  margin-left: -72px;
  margin-right: -72px;
  flex-wrap: wrap;
  width: calc(100% + 48px);
  height: 1px;
  background-color: #e0e7ec;
  margin: 24px 0px;

  @media screen and (max-width: 767px) {
    margin: 32px 0px;
  }
`;

const BaseIcon = styled.span`
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 16px;
  background-size: cover;
`;

export const LayersIcon = styled(BaseIcon)`
  background-image: url(${require('../../../../../assets/images/layers.svg')});
  height: 17px;
`;

export const LogoutIcon = styled(BaseIcon)`
  background-image: url(${require('../../../../../assets/images/logout.svg')});
`;

export const UserIcon = styled(BaseIcon)`
  background-image: url(${require('../../../../../assets/images/user-icon.svg')});
`;

export const ActionList = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  margin-left: -24px;
  margin-right: -24px;

  a {
    display: inline-block;
    padding: 16px 24px;
    font-size: 14px;
    color: #180a33;
    text-decoration: none;
    font-weight: 300;
    :hover {
      background-color: #f1f5f7;
    }
  }
`;

export const CloseButton = styled.button`
  background: url(${require('../../../../../assets/images/close-icon.svg')});
  position: absolute;
  border: 0;
  top: 20px;
  right: 24px;
  width: 16px;
  height: 16px;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;
